import * as React from 'react'
import { Link } from 'react-router-dom'

import { Icon, Select, SelectOption } from '../../components'
import ChartLayout from '../../models/chart_layout'
import { useChartTypes } from './use-chart-types'
import { TypeBaseOption } from './utils'

const isNativeMobileSelect = true // explicitly enable native select for mobile devices

export function ChartTypesSelect({
  isPremium,
  model,
  ...props
}: {
  isPremium: boolean
  model: ChartLayout
  theme?: string
  size?: string
  rounding?: string
}) {
  const { chartTypes, getCurrentType } = useChartTypes({ isPremium, model })
  const currentType = getCurrentType()
  const [selectedType, setSelectedType] = React.useState(currentType)
  const icon = chartTypes.find((item) => item.value === selectedType)?.iconName

  React.useEffect(() => {
    setSelectedType(currentType)
  }, [currentType])

  return (
    <Select
      {...props}
      data-testid="chart-type-select"
      aria-label="Chart type"
      value={selectedType}
      items={chartTypes}
      className="w-[7.25rem]"
      contentClass="truncate"
      listProps={{ rounding: props.rounding }}
      leftContent={
        props.theme === 'chip' ? (
          icon
        ) : (
          <Icon name={chartTypes.find((item) => item.value === selectedType)?.iconName} className="text-gray-300" />
        )
      }
      rightContent={props.theme === 'chip' ? 'caretDown' : undefined}
      hasPopoverButtonWidthLimit={false}
      isNativeMobileSelect={isNativeMobileSelect}
      onChange={(item: TypeBaseOption) => setSelectedType(item.value)}
    >
      {chartTypes.map((item) => (
        <SelectOption
          as={item.href ? Link : undefined}
          to={item.href}
          reloadDocument={item.href ? !window.FinvizSettings.hasUserPremium : undefined}
          data-testid={`chart-type-select-option-${item.value}`}
          key={item.value}
          leftContent={item.iconName}
          rounding={props.rounding}
        >
          {item.label}
        </SelectOption>
      ))}
    </Select>
  )
}
